import "./SectionUsersSidebarPanel.scss";

import type { FC, ReactNode } from "react";

import { SectionRole } from "../../../shared/types/roles";

import { SectionUserCard } from "./SectionUserCard";

import { t } from "i18n/i18n";
import { PersonStatusIcon } from "mds/icons";
import {
  EnhancedUserWithSectionActivity,
  SectionUserActivityStatus,
  selectSectionUserByUserIdMap,
} from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { getSectionResourceRole } from "utils/section";

interface SectionRoleCardProps {
  sectionRole: SectionRole;
  users: EnhancedUserWithSectionActivity[];
  className?: string;
  headerIcon?: ReactNode;
  separateUsersInClassSession?: boolean;
  showEmpty?: boolean;
  showOnlineCount?: boolean;
  startOpen?: boolean;
}

export const SectionRoleCard: FC<SectionRoleCardProps> = ({
  sectionRole,
  users,
  className,
  headerIcon,
  separateUsersInClassSession = false,
  showEmpty = false,
  showOnlineCount = false,
  startOpen = false,
}) => {
  const sectionUserMap = useObjectSelector(selectSectionUserByUserIdMap);
  const usersInRole = users.filter((user) => {
    const sectionUser = sectionUserMap[user.id];
    return sectionUser?.role === sectionRole && !sectionUser?.is_disabled;
  });
  const onlineUsers = usersInRole.filter(
    (user) => user.sectionActivityStatus !== SectionUserActivityStatus.OFFLINE,
  );
  const role = getSectionResourceRole(sectionRole);

  return (
    <SectionUserCard
      className={className}
      headerCount={
        showOnlineCount ? `${onlineUsers.length}/${usersInRole.length}` : `${usersInRole.length}`
      }
      headerIcon={
        headerIcon || (
          <PersonStatusIcon size="xs" statusColor={onlineUsers.length > 0 ? "green" : "gray"} />
        )
      }
      headerTitle={t(`roles.section_${role}_plural`)}
      separateUsersInClassSession={separateUsersInClassSession}
      showEmpty={showEmpty}
      startOpen={startOpen}
      users={usersInRole}
    />
  );
};
